import { CobaltClickableTile } from '@cae/cobalt-react/components/tile';
import { navigateToHelp } from '@shared/helpers/navigate-to-help/navigateToHelp';
import * as React from 'react';

import styles from './CustomerCareTile.module.css';
import { CustomerCareWidgetIllustration } from './illustration/CustomerCareWidgetIllustration';

const CustomerCareTile = React.memo((): React.ReactElement => {
  return (
    <CobaltClickableTile
      onClick={navigateToHelp}
      className={styles.customerCareTile}
      data-testid="customer-care-tile"
    >
      <CustomerCareWidgetIllustration />
      <div className={styles.customerCareTileContent}>
        <span className={`body-02 ${styles.customerCareTileTitle}`}>
          Customer care available 24/7
        </span>
        <span className={`body-02 ${styles.customerCareTileSubtitle}`}>
          Get ready for your upcoming visit
        </span>
      </div>
    </CobaltClickableTile>
  );
});

CustomerCareTile.displayName = 'CustomerCareTile';

export { CustomerCareTile };
